import React from "react"
import {FieldViewProps} from "../../../../render/view";

export default function FieldCheckbox_View(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    return <div className={Classes("ui5-cb", "s-{0}".f(props.field.size), {selected: value})}/>

}